import React from 'react';
import { Form } from 'semantic-ui-react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './FormUser.form';
import { User } from '../../../../api';
import { useAuth } from '../../../../hooks';

import './FormUser.css';

const userController = new User();

export function FormUser(props) {
    const { close, onReload, user } = props;
    const { accessToken } = useAuth();

    const formik = useFormik({
        initialValues: initialValues(user),
        validationSchema: validationSchema(user),
        validateOnChange: false,
        onSubmit: async (formValue) => {
            try {
                if (user) {
                    console.log('Update form: ',formValue);
                    await userController.updateUser(accessToken, user._id, formValue);
                    onReload();
                    close();
                } else {
                    console.log('Create form: ',formValue);
                    await userController.createUser(accessToken, formValue);
                    onReload();
                    close();
                }
            } catch (error) {
                console.error(error);
            }
        },
    });

  return (
    <div className='user'>
        <Form className='user__form' onSubmit={formik.handleSubmit}>
            
            <Form.Input
                type='text'
                name='firstName'
                label='First Name'
                placeholder='first name'
                onChange={formik.handleChange}
                value={formik.values.firstName}
                error={formik.errors.firstName}
            />

            <Form.Input
                type='text'
                name='lastName'
                label='Last Name'
                placeholder='last name'
                onChange={formik.handleChange}
                value={formik.values.lastName}
                error={formik.errors.lastName}
            />

            <Form.Input
                type='text'
                name='email'
                label='Email'
                placeholder='name@company.com'
                onChange={formik.handleChange}
                value={formik.values.email}
                error={formik.errors.email}
            />

            <Form.Input
                type='password'
                name='password'
                label='Password'
                placeholder='password'
                onChange={formik.handleChange}
                value={formik.values.password}
                error={formik.errors.password}
            />

            <Form.Select
                name='role'
                label='Role'
                options={role}
                placeholder='Select'
                onChange={(_, data) => formik.setFieldValue("role", data.value)}
                value={formik.values.role}
                error={formik.errors.role}
            />

            <Form.Group>
                <Form.Button className='button-create-user' type='submit' primary loading={formik.isSubmitting}>
                    {'Register User'}
                </Form.Button>
                <Form.Button className='button-cancel-user' type='button' secondary onClick={close}>
                    {"Cancel"}
                </Form.Button>
            </Form.Group>

            {/* <p className='register__form-p-error'>{error}</p> */}
        </Form>
    </div>
  )
}

const role = [
    {
        key: 'admin',
        text: 'Admin',
        value: 'ROLE_ADMIN'
    },
    {
        key: 'sales',
        text: 'Sales',
        value: 'ROLE_SALES'
    },
    {
        key: 'support',
        text: 'Support',
        value: 'ROLE_SUPPORT'
    },
]
